import React, { useMemo, useState } from 'react';
import { Tabs } from 'antd';
import styles from './s.module.less';
import QuestionCard from '../QuestionCard';
import QuestionEditModal from '../QuestionEditModal';
import MatchingProvider from '../MatchingProvider';
import MatchingProviderEditModal from '../MatchingProviderEditModal';
import { IClosedFunnelFilter, IClosedFunnelQuestion } from 'types/operation';

interface BlocksTabProps {
    questions?: IClosedFunnelQuestion[];
    filters?: IClosedFunnelFilter[];
    secondTab: string;
    setSecondTab: (key: string) => void;
    onSuccess?: () => void;
}

const BlocksTab: React.FC<BlocksTabProps> = ({ questions, filters, secondTab, setSecondTab, onSuccess }) => {
    const [subTab, setSubTab] = useState('active');
    const [editModalOpen, setEditModalOpen] = useState(false);
    const [editData, setEditData] = useState<any>(null);
    const [mpEditModalOpen, setMpEditModalOpen] = useState(false);
    const [mpEditData, setMpEditData] = useState<any>(null);

    const activeQuestions = useMemo(() => questions?.filter((q) => q.status === 'A') || [], [questions]);
    const inactiveQuestions = useMemo(() => questions?.filter((q) => q.status === 'D') || [], [questions]);

    const handleEdit = (q: any) => {
        setEditData(q);
        setEditModalOpen(true);
    };

    const handleSuccess = () => {
        setEditModalOpen(false);
        onSuccess?.();
    };

    const handleCancel = () => {
        setEditModalOpen(false);
    };

    const handleMpEdit = (item: any) => {
        setMpEditData(item);
        setMpEditModalOpen(true);
    };

    const handleMpSuccess = () => {
        setMpEditModalOpen(false);
        onSuccess?.();
    };

    const handleMpCancel = () => {
        setMpEditModalOpen(false);
    };

    const emptyRender = (emptyText: string) => {
        return (
            <div className={styles.emptyRender}>
                <div className={styles.emptyText}>{emptyText}</div>
                <div className={styles.emptyImg} />
            </div>
        );
    };

    return (
        <div className={styles.customTabsWrapper}>
            <div className={styles.customTabs}>
                <div
                    className={secondTab === 'questions' ? styles.tabActive : styles.tab}
                    onClick={() => setSecondTab('questions')}
                >
                    Questions
                </div>
                <div
                    className={secondTab === 'matching' ? styles.tabActive : styles.tab}
                    onClick={() => setSecondTab('matching')}
                >
                    Matching provider
                </div>
            </div>
            {secondTab === 'questions' && (
                <Tabs
                    activeKey={subTab}
                    onChange={setSubTab}
                    className={styles.antdSubTabs}
                    items={[
                        {
                            key: 'active',
                            label: `Active questions (${activeQuestions.length})`,
                            children: (
                                <>
                                    {
                                        activeQuestions && activeQuestions.length > 0 ? activeQuestions.map((q) => (
                                            <QuestionCard
                                                key={q.id}
                                                question={q.name}
                                                subtext={q.subtext}
                                                type={q.type}
                                                typeName={q.typeName}
                                                onEdit={() => handleEdit(q)}
                                            />
                                        )) : emptyRender('No active questions')
                                    }
                                </>
                            ),
                        },
                        {
                            key: 'inactive',
                            label: `Inactive questions (${inactiveQuestions.length})`,
                            children: (
                                <>
                                    {
                                        inactiveQuestions && inactiveQuestions.length > 0 ? inactiveQuestions.map((q) => (
                                            <QuestionCard
                                                key={q.id}
                                                question={q.name}
                                                subtext={q.subtext}
                                                type={q.type}
                                                typeName={q.typeName}
                                                onEdit={() => handleEdit(q)}
                                            />
                                        )) : emptyRender('No inactive questions')
                                    }
                                </>
                            ),
                        },
                    ]}
                />
            )}
            {secondTab === 'matching' && (
                <>
                    {/* 合并显示TREATMENT和NON_PRESCRIBABLE_MEDICATION类型的filters */}
                    {(() => {
                        const treatmentFilters = filters?.filter((filter) =>
                            filter.filterType === 'TREATMENT' || filter.filterType === 'NON_PRESCRIBABLE_MEDICATION',
                        ) || [];

                        if (treatmentFilters.length > 0) {
                            return (
                                <MatchingProvider
                                    key="treatment-provider"
                                    filters={treatmentFilters}
                                    onEdit={() => handleMpEdit(treatmentFilters)}
                                />
                            );
                        }
                        return null;
                    })()}

                    {/* 其他类型的filters单独显示 */}
                    {filters?.filter((filter) =>
                        filter.filterType !== 'TREATMENT' && filter.filterType !== 'NON_PRESCRIBABLE_MEDICATION',
                    ).map((item) => (
                        <MatchingProvider
                            key={item.id}
                            filters={[item]} // 单独的filter包装成数组
                            onEdit={() => handleMpEdit([item])}
                        />
                    ))}
                </>
            )}
            {editModalOpen && editData && (
                <QuestionEditModal
                    open={editModalOpen}
                    question={editData}
                    onSuccess={handleSuccess}
                    onCancel={handleCancel}
                />
            )}
            {mpEditModalOpen && mpEditData && (
                <MatchingProviderEditModal
                    open={mpEditModalOpen}
                    filters={mpEditData}
                    onSuccess={handleMpSuccess}
                    onCancel={handleMpCancel}
                />
            )}
        </div>
    );
};

export default BlocksTab;
